module.exports = __webpack_public_path__ + "img/img3.fw.19e548c4.png";